/* eslint-disable @typescript-eslint/explicit-function-return-type */
import config from '../config/index';

const journeyTemplateURL = `${config.ruleServerUrl}/users/journey-templates`;

export async function getJourneyTemplate() {
  return await fetch(journeyTemplateURL, {
    credentials: 'include',
    method: 'GET',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Content-type': 'application/json'
    }
  })
    .then(r => {
      return r.json();
    })
    .catch(err => {
      console.log(err);
    });
}
